import { render, staticRenderFns } from "./integral-history.vue?vue&type=template&id=38c0a734&scoped=true"
import script from "./integral-history.vue?vue&type=script&lang=js"
export * from "./integral-history.vue?vue&type=script&lang=js"
import style0 from "./integral-history.vue?vue&type=style&index=0&id=38c0a734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c0a734",
  null
  
)

export default component.exports